<template>
  <sf-text-button
    :color="errorColumn.count > 0 ? 'error' : 'grey'"
    :readonly="errorColumn.count === 0"
    :arial-label="$t('showErrorOrders')"
    @click="showSideMenuFn"
  >
    <v-icon v-if="errorColumn.count > 0" :size="32" :icon="mdiChevronLeft" />
    {{ $t('orderStatus.ERROR') }}
    <v-badge
      ref="countBadge"
      inline
      :content="errorColumn.count"
      :loading="errorColumn.loading"
      :color="errorColumn.count > 0 ? 'error' : 'grey'"
    />
  </sf-text-button>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import { OrderPreviewColumn } from '@/modules/order/types'
import { mdiChevronLeft } from '@mdi/js'
import { PropType } from 'vue'

const props = defineProps({
  errorColumn: {
    type: Object as PropType<OrderPreviewColumn>,
    required: true
  }
})

const emit = defineEmits<{
  (e: 'click'): void
}>()

const showSideMenuFn = () => {
  if (props.errorColumn.count > 0) {
    emit('click')
  }
}
</script>
